import React from 'react';
import './Sidebar.scss';
import { isMobile } from 'react-device-detect';

export const Sidebar = (props) => {
  const { children } = props;
  return (
    <div className={`sidebar${isMobile ? ' mobile' : ''}`}>
      {children}
      {isMobile && <div className='placeholder' />}
    </div>
  );
};
